import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
var m = {
  namespaced: true,
  state: {
    triangleInfo: {},
    triangleDetail: {},
    triangleGroupDetail: {}
  },
  mutations: {
    setTriangleInfo: function setTriangleInfo(state, _a) {
      var activityId = _a.activityId,
          data = _a.data;
      Vue.set(state.triangleInfo, activityId, data);
    },
    setTriangleDetail: function setTriangleDetail(state, _a) {
      var activityId = _a.activityId,
          data = _a.data;
      Vue.set(state.triangleDetail, activityId, data);
    },
    setTriangleGroupDetail: function setTriangleGroupDetail(state, _a) {
      var groupId = _a.groupId,
          data = _a.data;
      Vue.set(state.triangleGroupDetail, groupId, data);
    }
  },
  actions: {
    /**
     * 获取活动信息
     */
    getTriangleInfo: function getTriangleInfo(context, _a) {
      var activityId = _a.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/triangle/info', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setTriangleInfo', {
                  activityId: activityId,
                  data: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取详情
     */
    getTriangleDetail: function getTriangleDetail(context, _a) {
      var activityId = _a.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/triangle/detail', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setTriangleDetail', {
                  activityId: activityId,
                  data: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata.data];
          }
        });
      });
    },

    /**
     * 获取队伍详情
     */
    getTriangleGroupDetail: function getTriangleGroupDetail(context, _a) {
      var groupId = _a.groupId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/triangle/group_detail', {
                params: {
                  group_id: groupId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setTriangleGroupDetail', {
                  groupId: groupId,
                  data: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata.data];
          }
        });
      });
    },

    /**
     * 发起活动
     */
    postTriangle: function postTriangle(context, _a) {
      var activityId = _a.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/triangle', {
                activity_id: activityId
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 关闭活动
     */
    triangleCancel: function triangleCancel(context, _a) {
      var activityId = _a.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/triangle/cancel', {
                activity_id: activityId
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;